import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=8621d2cc&scoped=true&"
import script from "./VideoModal.vue?vue&type=script&lang=ts&"
export * from "./VideoModal.vue?vue&type=script&lang=ts&"
import style0 from "./VideoModal.vue?vue&type=style&index=0&id=8621d2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8621d2cc",
  null
  
)

export default component.exports